export default function ($translate) {
    return {
        KEYS: {
            FIELD: 'FIELD',
            DEPARTMENT: 'DEPARTMENT',
            ROLE: 'ROLE',
            LEVEL: 'LEVEL'
        },
        LABELS: {
            FIELD: $translate.instant('classifier.field'),
            DEPARTMENT: $translate.instant('classifier.department'),
            ROLE: $translate.instant('classifier.role'),
            LEVEL: $translate.instant('classifier.level')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/classifier/index.js